import { render, staticRenderFns } from "./AssignTopic.vue?vue&type=template&id=038a05df&scoped=true&"
import script from "./AssignTopic.vue?vue&type=script&lang=js&"
export * from "./AssignTopic.vue?vue&type=script&lang=js&"
import style0 from "./AssignTopic.vue?vue&type=style&index=0&id=038a05df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a05df",
  null
  
)

export default component.exports